import { Nullable } from '../../model';

interface Data {
    deleted_at: Nullable<string>;
    end_date: Nullable<string>;
}
export const filterByCurrentAuthority = (showHistorical: boolean = false) => (data: Data) => {
    if (data.deleted_at) return showHistorical;

    if (data.end_date) {
        const isExpired = Date.now() > new Date(data.end_date).getTime();
        return showHistorical ? isExpired : !isExpired;
    }

    return !showHistorical;
};